/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EegPdr
 */
export interface EegPdr {
    /**
     * 
     * @type {string}
     * @memberof EegPdr
     */
    'main'?: EegPdrMainEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof EegPdr
     */
    'sub'?: Array<EegPdrSubEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum EegPdrMainEnum {
    Present = 'PRESENT',
    Absent = 'ABSENT'
}
/**
    * @export
    * @enum {string}
    */
export enum EegPdrSubEnum {
    Artifacts = 'ARTIFACTS',
    LowVoltageRecord = 'LOW_VOLTAGE_RECORD',
    NoClosedEyes = 'NO_CLOSED_EYES',
    NoWakefulness = 'NO_WAKEFULNESS'
}


